import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'manik-button-loader',
  templateUrl: './manik-loader.component.html',
  styleUrls: ['./manik-loader.component.scss']
})
export class ManikLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}

@Component({
  selector: 'manik-data-loader',
  template: `<div class="cBizloader" style="--n: 5;">
  <div class="cBizloaderDot" style="--i: 0;"></div>
  <div class="cBizloaderDot" style="--i: 1;"></div>
  <div class="cBizloaderDot" style="--i: 2;"></div>
  <div class="cBizloaderDot" style="--i: 3;"></div>
  <div class="cBizloaderDot" style="--i: 4;"></div>
</div>`,
  styleUrls: ['./manik-loader.component.scss']
})
export class ManikDataLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
